module.exports = __webpack_public_path__ + "static/fonts/a7622e06-0cde-414a-a25d-5e5f6f5bfcaa.6885c19.ttf";